
import Swiper from "./swiper-bundle.esm.browser.min.js";
if (!customElements.get("card-slider")) {
    customElements.define(
      "card-slider",
      class CardSlider extends HTMLElement {
        constructor() {
          super();
          this.swiper = null; 
          this.filterSlides = this.filterSlides.bind(this);

        }
  
        connectedCallback() {
            this.isMobileSliderEnable = this.dataset.mobileSlider || false;
            this.initializeSwiper();
        }

        isMobile() {
          return window.innerWidth <= 1199;
        }

filterSlides() {
  const slides = Array.from(this.querySelectorAll('.swiper-slide'));
  const lastSlide = slides.length > 3 ? slides[slides.length - 1] : null;

  if (this.isMobile()) {
    if (lastSlide) lastSlide.style.display = 'none';
    slides[0].style.display = null;
    slides[0].style.opacity = '1';
  } else {
    // On desktop: show slide 0 normally, pre-position slide 3 invisible on top
    slides.forEach((slide, i) => {
      slide.style.display = 'block';
      slide.style.position = i === 0 ? 'relative' : 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
      slide.style.opacity = i === 0 ? '1' : '0';
      slide.style.transition = 'opacity 0.2s ease';
      slide.style.pointerEvents = i === 0 ? 'auto' : 'none';
    });
  }

  this.swiper?.update();
}




        initializeSwiper() {
            const swiperContainer = this.querySelector('.swiper-slider');
            const nextEl = this.querySelector('.swiper-button-next');
            const prevEl = this.querySelector('.swiper-button-prev');
            const pagination = this.querySelector('.swiper-pagination');
    
            if (!swiperContainer || !nextEl || !prevEl) {
              console.error('Swiper initialization failed due to missing elements.');
              return;
            }
    
            this.swiper = new Swiper(swiperContainer, {
              loop: false,
              navigation: {
                nextEl: nextEl,
                prevEl: prevEl,
              },
              pagination: {
                el: pagination,
              },
              breakpoints: {
                "320": {
                  enabled: this.isMobileSliderEnable
                },
                "900": {
                  enabled: true
                }
              },
              on: {
                init: () => {
                  this.filterSlides();
                },
                resize: () => {
                  this.filterSlides();
              }
              }
            })
            // After swiper is initialized, add hover behavior
swiperContainer.closest('card-slider').addEventListener('mouseenter', () => {
  if (!this.isMobile()) {
    const slides = Array.from(this.querySelectorAll('.swiper-slide'));
    const targetIndex = slides.length >= 4 ? 3 : slides.length > 1 ? 1 : null;
    if (targetIndex !== null) {
      slides[0].style.opacity = '0';
      slides[targetIndex].style.opacity = '1';
    }
  }
});

swiperContainer.closest('card-slider').addEventListener('mouseleave', () => {
  if (!this.isMobile()) {
    const slides = Array.from(this.querySelectorAll('.swiper-slide'));
    slides.forEach((slide, i) => {
      slide.style.opacity = i === 0 ? '1' : '0';
    });
  }
});


          }
    
          disconnectedCallback() {
            if (this.swiper) {
              this.swiper.destroy(true, true);
              this.swiper = null;
            }
          }

    },
    );
  }
  